import { mathRound, newMathFormat } from '@gp/utils/common';
import { DEFAULT_PERCENTAGE_FRACTION_DIGITS, DEFAULT_PERCENTAGE_LIMIT } from '../constants';

export const isValidPercentage = (value?: any): { isValid: boolean; value: number; } => {
  const valueNum = Number.parseFloat(value);
  return {
    isValid: !Number.isNaN(valueNum) && valueNum !== 0,
    value: valueNum,
  };
};

export const newMathFormatOfDevBudget = (payload: any) => newMathFormat(payload, false, 1);

export const formatPercentageInner = (value: number, options?: { fractionDigits?: number; limit?: number; }): string => {
  const { fractionDigits = DEFAULT_PERCENTAGE_FRACTION_DIGITS, limit = DEFAULT_PERCENTAGE_LIMIT } = options || {};
  const valueTmp = mathRound(value * 100, fractionDigits) as number;
  if (valueTmp > 0 && valueTmp >= limit) return `+${limit}%`;
  if (valueTmp < 0 && valueTmp <= -limit) return `-${limit}%`;
  // eslint-disable-next-line no-nested-ternary, prettier/prettier
  const valueSymbol = value > 0 ? '+' : (valueTmp === 0 ? '-' : '');
  return `${valueSymbol}${valueTmp}%`;
};

export const formatPercentage = (
  value?: any,
  options?: { fractionDigits?: number; limit?: number; placeholder?: string; },
): string => {
  const { placeholder = '-', ...restOptions } = options || {};
  const { isValid, value: valueNum } = isValidPercentage(value);
  if (!isValid) return placeholder;
  return formatPercentageInner(valueNum, restOptions);
};
